'use strict';
// 返回采编图片读取地址的格式
angular.module('trsWcmPicModule', []).filter('trsWcmPic', [
    function() {
        return function(input) {
            if (angular.isDefined(input)) {
                if (input) {
                    input = '/wcm/app/scm/file/read_image.jsp?FileName=' + input;
                }
                return input;
            }
        };
    },
]);
